// extracted by mini-css-extract-plugin
export default {"normalButton":"normalButton-jO3YUr","root":"root-Bk4LCs","card":"card-HNUgTY","securityPage":"securityPage-Qf5QCI"};